<template>
    <div>
        <div class="simple-row">
            <div class="left">
                <a class="swb-btn swb-btn-small" @click="toPrint">打印</a>
            </div>
        </div>
        <div class="content-caption dashed">
            <span>验收单信息</span>
            <div class="shrink-tab fr" :class="showReceiptFlag? 'current': ''" @click="doShowReceipt()">
                <span>{{ showReceiptFlag ? '隐藏' : '展开' }}</span>
                <i :class="showReceiptFlag? 'el-icon-arrow-down': 'el-icon-arrow-right'"></i>
            </div>
        </div>
        <template v-if="showReceiptFlag">
            <div class="simple-form flex col-3">
                <div class="form-group">
                    <div class="form-label">
                        <label>验收单号</label>
                    </div>
                    <div class="form-value">
                        <span>{{ receipt.no || '无' }}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>公司编码</label>
                    </div>
                    <div class="form-value">
                        <span>{{ receipt.buyerRealComCode || '' }}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>公司名称</label>
                    </div>
                    <div class="form-value">
                        <span>{{ receipt.buyerRealComName || '' }}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>所属业务单元</label>
                    </div>
                    <div class="form-value">
                        <span>{{ receipt.buyerBizUnitName || '' }}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>验收日期</label>
                    </div>
                    <div class="form-value">
                        <span>{{ receipt.confirmTime || '' }}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>成本中心</label>
                    </div>
                    <div class="form-value">
                        <span>{{ receipt.costCenterCode || '' }}</span>
                    </div>
                </div>

                <div class="form-group">
                    <div class="form-label">
                        <label>服务商公司名称</label>
                    </div>
                    <div class="form-value">
                        <span>{{ receipt.sellerRealComName || '' }}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>服务商标识</label>
                    </div>
                    <div class="form-value">
                        <span>{{ receipt.buyerInnerSellerCode || '' }}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>已作废</label>
                    </div>
                    <div class="form-value">
                        <span v-if="receipt.invalid">是</span>
                        <span v-else>否</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>作废原因</label>
                    </div>
                    <div class="form-value">
                        <span>{{ receipt.invalidCause || '' }}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>发票类型</label>
                    </div>
                    <div class="form-value">
                        <span>{{ invoiceTypeMap[receipt.invoiceType] }}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>税率(%)</label>
                    </div>
                    <div class="form-value">
                        <span>{{ parseFloat(receipt.taxRate || 0).toFixed(2) }}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>是否抵扣税</label>
                    </div>
                    <div class="form-value">
                        <span>{{ receipt.taxOffset ? '是' : '否' }}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>含税金额(元)</label>
                    </div>
                    <div class="form-value">
                        <span>{{ (receipt.wtxAmount || 0).toFixed(2) }}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>未税金额(元)</label>
                    </div>
                    <div class="form-value">
                        <span>{{ (receipt.ntxAmount || 0).toFixed(2) }}</span>
                    </div>
                </div>
            </div>
        </template>
        <div class="content-caption dashed">
            <span>工单费用信息</span>
            <div class="shrink-tab fr" :class="showFeeItemListFlag? 'current': ''" @click="doShowFeeItemList()">
                <span>{{ showFeeItemListFlag ? '隐藏' : '展开' }}</span>
                <i :class="showFeeItemListFlag? 'el-icon-arrow-down': 'el-icon-arrow-right'"></i>
            </div>
        </div>
        <div v-if="showFeeItemListFlag" class="table-layout">
            <el-table :data="receipt.feeItemList" border maxHeight="400" ref="feeItemTable" show-summary :summary-method="getFeeItemSum">
                <el-table-column prop="feeType" label="费用类型" align="center" width="205">
                    <template slot-scope="rows">
                        <span>{{ workFeeTypeMap[rows.row.feeType] }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="feeName" label="费用名称" width="300" align="left"></el-table-column>
                <el-table-column prop="amount" label="费用金额(元)" align="right" width="200">
                    <template slot-scope="rows">
                        <span v-if="rows.row.amount != null">{{ rows.row.amount.toFixed(2) }}</span>
                        <span v-else>0.00</span>
                    </template>
                </el-table-column>
                <el-table-column prop="taxRate" label="税率(%)" align="right" :render-header="renderTaxRate">
                    <template slot-scope="rows">
                        <span v-if="rows.row.taxRate != null">{{ rows.row.taxRate.toFixed(2) }}</span>
                        <span v-else>0.00</span>
                    </template>
                </el-table-column>
                <el-table-column prop="settleAmount" label="应结算金额(元)" align="right" width="200">
                    <template slot-scope="rows">
                        <span v-if="rows.row.settleAmount != null">{{ rows.row.settleAmount.toFixed(2) }}</span>
                        <span v-else>0.00</span>
                    </template>
                </el-table-column>
                <el-table-column prop="settleAmountX" label="纳入结算金额(元)" align="right" width="200">
                    <template slot-scope="rows">
                        <span v-if="rows.row.settleAmountX != null && rows.row.settleInvolved">{{ rows.row.settleAmountX.toFixed(2) }}</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" width="300" prop="settleInvolved" label="纳入结算单">
                    <template slot-scope="rows">
                        <span>{{ rows.row.settleInvolved ? '√' : '' }}</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="content-caption dashed" v-if="!receipt.invalid">
            <span>工单列表</span>
            <div class="shrink-tab fr" :class="showWorkVoucherListFlag? 'current': ''" @click="doShowWorkVoucherList()">
                <span>{{ showWorkVoucherListFlag ? '隐藏' : '展开' }}</span>
                <i :class="showWorkVoucherListFlag? 'el-icon-arrow-down': 'el-icon-arrow-right'"></i>
            </div>
        </div>
        <div v-if="showWorkVoucherListFlag && !receipt.invalid" class="table-layout">
            <el-table :data="receipt.workVoucherList" border style="width: 100%" maxHeight="400" ref="dataTable" :summary-method="getWorkItemSum" show-summary>
                <el-table-column prop="no" label="工单号" align="center"></el-table-column>
                <el-table-column prop="servcType" label="工单类型" width="100" align="center">
                    <template slot-scope="rows">
                        <span>{{ servcTypeMap[rows.row.servcType] }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="devcTitle" width="180" label="设备名称" align="left" show-overflow-tooltip></el-table-column>
                <el-table-column prop="devcGroupFullName" label="维保分组" width="140" align="left" show-overflow-tooltip></el-table-column>
                <el-table-column prop="tmpNo" label="系统编号" width="180" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column prop="toDoorFee" label="上门费(元)" width="100" align="right">
                    <template slot-scope="rows">
                        <span v-if="rows.row.toDoorFee != null">{{ rows.row.toDoorFee.toFixed(2) }}</span>
                        <span v-else>0.00</span>
                    </template>
                </el-table-column>
                <el-table-column prop="generallFee" label="服务费(元)" width="100" align="right">
                    <template slot-scope="rows">
                        <span v-if="rows.row.generallFee != null">{{ rows.row.generallFee.toFixed(2) }}</span>
                        <span v-else>0.00</span>
                    </template>
                </el-table-column>
                <el-table-column prop="accFee" label="配件费(元)" width="100" align="right">
                    <template slot-scope="rows">
                        <span v-if="rows.row.accFee != null">{{ rows.row.accFee.toFixed(2) }}</span>
                        <span v-else>0.00</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" width="60" prop="settleFree" label="无需结算">
                    <template slot-scope="rows">
                        <span>{{ rows.row.settleFree ? '是' : '否' }}</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" width="60" prop="freeFlag" label="是否免费">
                    <template slot-scope="rows">
                        <span>{{ rows.row.freeFlag ? '免费' : '收费' }}</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" width="100" prop="violated" label="是否违约">
                    <template slot-scope="rows">
                        <span class="font-red" v-if="rows.row.violated && rows.row.violateState == 1">违约（未处理）</span>
                        <span class="font-green" v-else-if="rows.row.violated && rows.row.violateState == 0">违约（已处理）</span>
                        <span v-else-if="!rows.row.violated">正常</span>
                    </template>
                </el-table-column>
                <el-table-column align="left" prop="violateHandleDesc" label="违约处理说明" show-overflow-tooltip></el-table-column>
                <el-table-column prop="" label="操作" width="100" align="center">
                    <template slot-scope="rows">
                        <a class="swb-btn-link" @click="handleViolate(rows.row)" v-if="showViolateBtn && rows.row.violated && rows.row.violateState == 1 && !rows.row.workReceipConfirmFlag">处理违约</a>
                        <a class="swb-btn-link" @click="createWorkVoucher(rows.row)" v-if="createWorkBtn && rows.row.violated && !rows.row.workReceipConfirmFlag">补发工单</a>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
    import {Utils} from '../../app.base'
    import {MsgBox} from '../../app.vues'

    import receiptApi from '../../api/receipt'
    import servcDelivApi from '../../api/servcDeliv';

    export default {
        name: 'swb-servc-work-receipt-detail',
        desc: '工单验收单详情',
        props: ["id", "showViolateBtn", "createWorkBtn"],
        data: function () {
            return {
                receipt: {},
                //
                workFeeTypeMap: getEnumMap('servcFeeType', 'value2text'),
                servcTypeMap: getEnumMap("servcType", "value2text"),
                invoiceTypeMap: getEnumMap("invoiceType", "value2text"),
                //
                showReceiptFlag: true,
                showFeeItemListFlag: true,
                showWorkVoucherListFlag: true,
            }
        },
        created: function () {
            if (!Utils.isNoB(this.id)) {
                this.getServcWorkReceiptDetail();
            }
        },
        methods: {
            // render 事件
            renderTaxRate(h, {column}) {
                return h(
                    'div',
                    [
                        h('span', column.label),
                        h('el-tooltip', {
                            class: 'item fr',
                            props: {
                                effect: 'light',
                                placement: 'top'
                            }
                        }, [
                            h('span', {
                                class: 'font-black',
                                style: 'white-space: pre-wrap',
                                slot: 'content'
                            }, '指合同签约时，约定的预定税率。'),
                            h('span', {
                                style: 'col-title-tooltip-wrapper'
                            }, [
                                h('a', {
                                    class: 'el-icon-warning col-title-tooltip',
                                    style: 'color:red;margin-left:5px;'
                                })
                            ])
                        ])
                    ],
                );
            },
            // 查看购置验收单详情
            getServcWorkReceiptDetail: function () {
                let self = this;
                //
                let postData = {};
                postData.id = self.id;
                let msgBoxDlg = MsgBox.loading();
                receiptApi.getServcWorkReceiptInfo(postData, function (result) {
                    msgBoxDlg.close();
                    if (result.type == 'info') {
                        let receipt = result.data || {};
                        let feeItemList = receipt.feeItemList || [];
                        for (let i = 0; i < feeItemList.length; i++) {
                            let feeItem = feeItemList[i];
                            if (Utils.isTrue(feeItem.settleInvolved)) {
                                feeItem.settleAmountX = feeItem.settleAmount;
                            }
                        }
                        receipt.feeItemList = Utils.merge([], feeItemList);
                        self.receipt = Utils.merge({}, receipt);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 隐藏、展开
            doShowReceipt: function () {
                this.showReceiptFlag = !this.showReceiptFlag;
            },
            // 隐藏、展开
            doShowFeeItemList: function () {
                this.showFeeItemListFlag = !this.showFeeItemListFlag;
            },
            // 隐藏、展开
            doShowWorkVoucherList: function () {
                this.showWorkVoucherListFlag = !this.showWorkVoucherListFlag;
            },
            // 汇总费用
            getFeeItemSum: function (param) {
                const {columns, data} = param;
                const sums = [];
                columns.forEach((column, index) => {
                    if (index === 0) {
                        sums[index] = '合计';
                        return;
                    }
                    let flag = true;
                    let values = data.map(item => Number(item[column.property]));
                    if (column.property == 'amount') {
                        values = data.map(item => Number(item['amount']));
                    } else if (column.property == 'settleAmount') {
                        values = data.map(item => Number(item["settleAmount"]));
                    } else if (column.property == 'settleAmountX') {
                        values = data.map(item => Number(item["settleAmountX"]));
                    } else {
                        flag = false;
                    }
                    if (flag && !values.every(value => isNaN(value))) {
                        sums[index] = values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return (parseFloat(prev) + parseFloat(curr)).toFixed(2);
                            } else {
                                return parseFloat(prev).toFixed(2);
                            }
                        }, 0);
                        sums[index] += ' 元';
                    } else if (flag && values.every(value => isNaN(value))) {
                        sums[index] = '0.00 元';
                    } else {
                        sums[index] = '-';
                    }
                });
                return sums;
            },
            // 汇总费用
            getWorkItemSum: function (param) {
                const {columns, data} = param;
                const sums = [];
                columns.forEach((column, index) => {
                    if (index === 0) {
                        sums[index] = '合计';
                        return;
                    }
                    let flag = true;
                    let values = data.map(item => Number(item[column.property]));
                    if (column.property == 'toDoorFee') {
                        values = data.map(item => Number(item['toDoorFee']));
                    } else if (column.property == 'generallFee') {
                        values = data.map(item => Number(item['generallFee']));
                    } else if (column.property == 'accFee') {
                        values = data.map(item => Number(item["accFee"]));
                    } else {
                        flag = false;
                    }
                    if (flag && !values.every(value => isNaN(value))) {
                        sums[index] = values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return (parseFloat(prev) + parseFloat(curr)).toFixed(2);
                            } else {
                                return parseFloat(prev).toFixed(2);
                            }
                        }, 0);
                        sums[index] += ' 元';
                    } else {
                        sums[index] = '-';
                    }
                });
                return sums;
            },
            // 处理违约
            handleViolate: function (row) {
                let self = this;
                self.$prompt('请输入违约处理结果说明', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                }).then(function (data) {
                    if (Utils.isNoB(data.value)) {
                        MsgBox.warning("请输入违约处理说明！");
                        return;
                    }
                    let postData = {
                        id: row.id,
                        violateHandleDesc: data.value
                    };
                    let theLoad = MsgBox.loading();
                    servcDelivApi.doHandleServcWorkVoucherViolate(postData, function (result) {
                        theLoad.close();
                        if (result.type == 'info') {
                            MsgBox.success("操作成功");
                            //
                            self.getServcWorkReceiptDetail();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {
                });
            },
            createWorkVoucher(row) {
                // 补发工单
                let self = this;
                //弹出确认框
                this.$confirm('确定要补发工单吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let postData = {
                        id: row.id
                    };
                    let theLoad = MsgBox.loading();
                    servcDelivApi.doServcWorkVoucherExpiatoryCreate(postData, function (result) {
                        theLoad.close();
                        if (result.type == 'info') {
                            MsgBox.success("操作成功");
                            self.getServcWorkReceiptDetail();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {

                });
            },
            toPrint() {
                let collapsedBlocks = [];
                // 验收单信息 mainInfo
                if (!this.showReceiptFlag) {
                    collapsedBlocks.push('mainInfo');
                }
                // 工单费用信息 feeItems 纳入结算单 settleInvolved
                if (!this.showFeeItemListFlag) {
                    collapsedBlocks.push('feeItems');
                }
                // 工单列表 workVoucherList 是否违约 violated
                if (!this.showWorkVoucherListFlag) {
                    collapsedBlocks.push('workVoucherList');
                }

                let receipt = this.receipt;
                let url = '/voucher/print/jsp';
                let params = {
                    bizType: 'biz.proof.gongdan.yanshou',
                    voucherId: receipt.id,
                    collapsedBlocks: collapsedBlocks.join(',')

                };
                let printUrl = Utils.makeUrl(getAppUrl(url), params);
                Utils.setPageUrl(printUrl, '_blank');
            }
        }
    }
</script>

<style>
    .el-table th.gutter {
        display: initial;
    }
</style>



// WEBPACK FOOTER //
// src/compo/receipt/ServcWorkReceiptDetail.vue